import { Button } from '@rematter/ui-web';
import { ContentCard } from '@rematter/ui-web';
import { useAtomValue, useSetAtom } from 'jotai';

import * as loadDetailsState from '../../_state/loadDetails.state';
import * as reconciliationState from '../../_state/loadReconciliation.state';

import { LoadDeductionsSection } from './LoadDeductionSection';
import { LoadLineItem } from './LoadLineItem';
import { LoadTotals } from './LoadTotals';

import useDebouncedValue from '~/shared/hooks/useDebounce';

export const LoadTabMaterials = () => {
  const { data: loadDetails } = useAtomValue(loadDetailsState.$loadDetails);
  const canSave = useAtomValue(reconciliationState.$canSaveReconciliation);
  const hasLocalChanges = useAtomValue(reconciliationState.$hasLocalChanges);
  const canEditReconciliation = useAtomValue(
    reconciliationState.$canEditReconciliation,
  );
  const saveReconciliation = useSetAtom(
    reconciliationState.$saveLoadReconciliation,
  );
  const discardReconciliationChanges = useSetAtom(
    reconciliationState.$discardReconciliationChanges,
  );

  const debouncedCanSave = useDebouncedValue(canSave, 100);

  return (
    <div className="@LoadTabMaterials flex h-full flex-col gap-3 p-5">
      <div className="no-scrollbar flex flex-col gap-2.5 overflow-y-auto">
        {loadDetails?.lineItems?.map((lineItem) => (
          <LoadLineItem key={lineItem.id} lineItem={lineItem} />
        ))}
        <LoadDeductionsSection />
      </div>
      <ContentCard className="pt-5">
        <div className="flex items-center gap-10">
          <LoadTotals />
          {canEditReconciliation && (
            <div className="flex gap-2">
              <Button
                variant="outline"
                color="neutral"
                className="border-neutral/20"
                onClick={discardReconciliationChanges}
                isDisabled={!hasLocalChanges}
              >
                Discard changes
              </Button>
              <Button
                onClick={saveReconciliation}
                isDisabled={!debouncedCanSave}
              >
                Save Updates
              </Button>
            </div>
          )}
        </div>
      </ContentCard>
    </div>
  );
};
